export default __webpack_public_path__ + "static/media/connection-requests.1ac02f21.jpg";